"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Touch = (0, _helpers.getImageByAgent)('illustrations-car-spinner-24.gif');
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  opacity: ", ";\n  flex-direction: column;\n  align-items: center;\n  padding-top: 10px;  \n  \n  .loader-container {\n    display: flex;\n    align-items: flex-end;\n    padding-top: 50px;\n    position: relative;\n    right: 20px;\n    \n    @media screen and (max-width: ", "px) {\n      right: 0;\n    }\n  }\n  \n  .loader,\n  .loader:after {\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n  }\n  .loader:before {\n    content: '';\n    display: block;\n    width: 22px;\n    height: 22px;\n    background-color: ", ";\n    border-radius: 20px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  .loader {\n    left: 0px;\n    top: -50px;\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 5px solid transparent;\n    border-right: 5px solid ", "\n    border-bottom: 5px solid transparent;\n    border-left: 5px solid ", ";\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: load8 1.1s infinite linear;\n    animation: load8 1.1s infinite linear;\n  }\n  .loader-image {\n    max-width: 100%;\n  }\n  @-webkit-keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"])), function (props) {
  if (props.show) {
    return 1;
  }
  return 0;
}, _breakpoints.default.mobile, _helpers.agentDeveloperUtils.getSecondaryColor(550), _helpers.agentDeveloperUtils.getSecondaryColor(300), _helpers.agentDeveloperUtils.getSecondaryColor(300));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    text: {
      color: theme.palette.secondary.main,
      fontSize: theme.typography.pxToRem(24.2),
      marginTop: 30,
      textAlign: 'center'
    }
  };
});
var Loader = function Loader(props) {
  var children = props.children,
    _props$show = props.show,
    show = _props$show === void 0 ? true : _props$show,
    className = props.className,
    image = props.image,
    imageClassName = props.imageClassName,
    textClassName = props.textClassName,
    imageContainerClassName = props.imageContainerClassName;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className,
    show: show
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: imageContainerClassName ? imageContainerClassName : 'loader-container'
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: imageClassName ? imageClassName : 'loader-image',
    src: image ? image : Touch,
    alt: "loading"
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: textClassName ? textClassName : classes.text
  }, children));
};
Loader.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  image: _propTypes.default.string,
  imageClassName: _propTypes.default.string,
  imageContainerClassName: _propTypes.default.string,
  show: _propTypes.default.bool,
  textClassName: _propTypes.default.string
};
var _default = exports.default = Loader;